import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrentUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#021927",
			fillRule: "evenodd",
			d: "M20.8 12.8a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0Zm-1.6 0a3.2 3.2 0 1 1-6.4 0 3.2 3.2 0 0 1 6.4 0Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#021927",
			d: "M16 20c-5.18 0-9.592 3.063-11.273 7.354.41.406.84.79 1.292 1.152C7.27 24.566 11.198 21.6 16 21.6c4.803 0 8.73 2.966 9.982 6.906a16.6 16.6 0 0 0 1.292-1.152C25.593 23.063 21.18 20 16 20Z"
		})
	]
});
export { SvgCurrentUser as ReactComponent };
